import {
    Button,
    FormControl,
    Stack,
    useDisclosure,
    Input,
    Textarea,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
} from "@chakra-ui/react";
import { getCompanyHistory, deleteCompanyHistory, updateCompanyHistory } from "../../../services/CompanyHistoryAPI";
import { useState } from "react";

const HistoryCard = (props) => {
    const editModal = useDisclosure();
    const deletionAlert = useDisclosure();

    const [year, setYear] = useState(props.history.year);
    const [content, setContent] = useState(props.history.content);

    const handleDeleteButton = () => {
        deleteCompanyHistory(props.history.id)
            .then(() => {
                props.updateCompanyHistoryCards(); //회사 연혁 카드 업데이트
                deletionAlert.onClose();
            })
            .catch((ex) => {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            });
    };

    const handleUpdateButton = () => {
        updateCompanyHistory(props.history.id, year, content)
            .then(() => {
                getCompanyHistory().then((result) => {
                    props.updateCompanyHistoryCards(); //회사 연혁 카드 업데이트
                    editModal.onClose();
                });
            })
            .catch((ex) => {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            });
    };

    const openEditModal = () => {
        setYear(props.history.year);
        setContent(props.history.content);
        editModal.onOpen();
    };

    return (
        <>
            <Stack direction="row" spacing={3}>
                <Button onClick={openEditModal}>수정</Button>
                <Button onClick={deletionAlert.onOpen}>삭제</Button>
                <div className="text-4xl text-[#a30b0b] font-bold w-40">{props.history.year}</div>
                <div className="text-4xl font-medium w-full">{props.history.content}</div>
            </Stack>

            <Modal onClose={editModal.onClose} isOpen={editModal.isOpen} isCentered>
                <ModalOverlay />

                <ModalContent h="300px" maxW="700px">
                    <ModalHeader p="20px">
                        <div className="text-4xl pb-[10px]">수정</div>
                        <div className="text-2xl">텍스트 박스를 클릭해 내용을 수정하고 저장 버튼을 클릭해주세요</div>
                    </ModalHeader>

                    <ModalBody p="20px">
                        <FormControl>
                            <Stack direction="row" spacing={3}>
                                <Input
                                    variant="outline"
                                    defaultValue={year}
                                    fontSize="4xl"
                                    py="20px"
                                    type="number"
                                    w="15%"
                                    value={year || ""}
                                    onChange={(event) => setYear(event.target.value)}
                                ></Input>

                                <Textarea
                                    defaultValue={"ff"}
                                    fontSize="4xl"
                                    w="85%"
                                    h="100px"
                                    value={content || ""}
                                    onChange={(event) => setContent(event.target.value)}
                                ></Textarea>
                            </Stack>
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button fontSize="4xl" onClick={editModal.onClose}>
                            취소
                        </Button>
                        <Button fontSize="4xl" onClick={handleUpdateButton}>
                            저장
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <AlertDialog isOpen={deletionAlert.isOpen} onClose={deletionAlert.onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="4xl" fontWeight="bold">
                            삭제
                        </AlertDialogHeader>

                        <AlertDialogBody fontSize="4xl">작성한 내용을 삭제하시겠습니까?</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button fontSize="4xl" onClick={deletionAlert.onClose}>
                                취소
                            </Button>
                            <Button fontSize="4xl" colorScheme="red" onClick={handleDeleteButton} ml={3}>
                                삭제
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
};

export default HistoryCard;
